import { MasterLeg } from '../../../../../../models/MasterLeg';

export const empty_master_leg_terms: MasterLeg = {
  // common leg fields
  notional: null,
  currency_id: 1,
  collateral_currency: null,
  //discounting_index_id: null,
  day_count_id: null,
  // notional exchange fields
  //toggle_notional_exchange_fields_flag: false,
  initial_notional_exchange: false,
  intermediary_notional_exchange: false,
  final_notional_exchange: false,
  // Dates
  effective_date: null,
  maturity_date: null,
  settlement_date: null,
  pay_frequency: null,
  //pay_start_end: 2,
  payment_offset: 0,
  business_day_convention: null,
  first_payment_date: null,
  next_to_last_payment_date: null,
  calendar_currencies: null,
  calculation_calendar: null,
  // Fixed Leg Fields
  //calc_basis_id: null,
  //coupon: null,
  // Floating Leg Fields
  //forecasting_index_id: null,
  //spread: null,
  // Cap Floor Fields
  //strike: null,
  //volatility: null,
  // Inflation Fields
  initial_index: null,
  inflation_base_date: null,
  inflation_lag: null,
  // Deprecated fields
  // date roll fields
  toggle_roll_fields_flag: false,
  eom_roll: true,

  //required for build
  //inflation_lag: null,
};
